<template>
      <div >
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false">
      <md-dialog-title class = "heading" v-if="mode==='Booking'">Assign Booking</md-dialog-title>
      <md-dialog-content >
        <form id = "top" novalidate @submit.prevent="doSaveUser">
        <div v-if="mode==='Booking'" class = "down">
            
            <p>{{selected}}</p>
        </div>
        <div class = "alwaysShow">
          
            <md-dialog-actions v-if="mode==='Booking'">
              <md-button class="md-raised custButton " @click="cancalAction"><span class="icons-center material-icons">cancel</span>Close</md-button>
              <md-button type="submit" class="md-raised custButton "><span class="icons-center material-icons">create</span>Create</md-button>
            </md-dialog-actions>


          
            <md-dialog-actions v-if="mode==='Instruction'">
              <md-button class="md-raised custButton " @click="cancalAction"><span class="icons-center material-icons">cancel</span>Close</md-button>
              <md-button type="submit" class="md-raised custButton "><span class="icons-center material-icons">create</span>Done</md-button>
            </md-dialog-actions>
        

          
        </div>

        <div v-if="mode==='Booking'">
          <md-table v-model="items" md-sort="name" md-sort-order="asc" md-card @md-selected="onSelect">
      <md-table-toolbar>
        <h1 v-if="items.length === 0" class="md-title">You don't have any bookings.</h1>
        <h1 v-else class="md-title">{{items.length}} Bookings Avalibe</h1>
      </md-table-toolbar>

      <md-table-row slot="md-table-row" slot-scope="{ item }"  md-selectable="single">
        <md-table-cell md-label="Order Type" md-sort-by="deliveryType">{{ item.deliveryType }}</md-table-cell>
        <md-table-cell md-label="Carrier" md-sort-by="carrierID">{{ item.carrierID }}</md-table-cell>
        <md-table-cell md-label="Cut off" md-sort-by="cutLFD">{{ item.cutLFD }}</md-table-cell>
        <md-table-cell md-label="Booking" md-sort-by="bookObl">{{ item.bookObl }}</md-table-cell>
        <md-table-cell md-label="Customer Order" md-sort-by="deliveryOrder">{{ item.deliveryOrder }}</md-table-cell>
        <md-table-cell md-label="Container Open" md-sort-by="ctnrCount">{{ item.ctnrCount }}</md-table-cell>
        <md-table-cell md-label="Container Assign" md-sort-by="ctnrCount">{{ item.ctnrCount }}</md-table-cell>
        <md-table-cell md-label="Pick up location" md-sort-by="pickupLoc">{{ item.pickupLoc }}</md-table-cell>
        <md-table-cell md-label="Delivery Location" md-sort-by="deliveryTo">{{ item.deliveryTo }}</md-table-cell>
        <md-table-cell md-label="CTN Pickup" md-sort-by="ctnrPickup">{{ item.ctnrPickup }}</md-table-cell>
        <md-table-cell md-label="CTN Drop-off" md-sort-by="ctnrDropOff">{{ item.ctnrDropOff }}</md-table-cell>
      </md-table-row>
    </md-table>
        </div>


        <div v-if="mode==='Instruction'">

          <h1 class = "heading">Instruction for Driver</h1>
          <md-field>
            <label>Description</label>
            <md-textarea v-model="item.dispatcherInstruction" md-counter="80"></md-textarea>
          </md-field>
        </div>
        </form>
      </md-dialog-content>
    </md-dialog>
  </div>
</template>

<style scoped>
form {
    min-width: 640px;
    margin: 24px;
    
}
  

.alwaysShow {
  position: fixed;
  
  right: 60px;
  top : 30px;
}

.redButton{

        background-color: #c50000;
        z-index: 4;
        box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
    }


.icons-center {
    vertical-align: middle;
    margin-right: 10px;
}

.custButton {
    margin: 10px;
    width: 120px;
    height: 40px;
    line-height:40px;
    font-size: 0.9rem;
   
}

.heading{
      padding-top: 10px;
     margin-bottom: 0;
      color: #555555;
      width: 92%;
      line-height: 3;
      font-size: 40px;
      font-family: Roboto Slab;
      margin-left: 44px;


}

.layout{
      padding-top: 7px;
      padding-bottom: 7px;
      width: 92%;
      line-height: 1.5;
      color: #555555;
    
      font-family: Roboto Slab;
      margin: auto;
}


.md-table-row
{
  background: white;
}


.md-table.md-theme-default .md-table-row.md-selected-single
{
background: #726a95;
}



</style>



<script>
  import { validationMixin } from 'vuelidate';
  import { mapGetters } from 'vuex';
  import dateFormat from '../utils/dateFormat';
  import { minLength, required , maxLength} from 'vuelidate/lib/validators';
  //import api from '../api';
  import { newAPIPost } from '../api/index.js';


  const getInitialdataForm = () => ({
    salesOffice: null
  });

  export default {
    mixins: [validationMixin],
    props: {
      mode: String,
    },
    data: () => ({
      showDialog: false,
      dataForm: getInitialdataForm(),
      loadList: [],
      dispatchers: [],
      ccicQcUsers: [],
      selected: {},
      instruction: null,
      item: [],
      items: [
        {
          id: 1,
          name: 'Shawna Dubbin',
          email: 'sdubbin0@geocities.com',
          gender: 'Male',
          title: 'Assistant Media Planner'
        },
        {
          id: 2,
          name: 'Odette Demageard',
          email: 'odemageard1@spotify.com',
          gender: 'Female',
          title: 'Account Coordinator'
        },
        {
          id: 3,
          name: 'Lonnie Izkovitz',
          email: 'lizkovitz3@youtu.be',
          gender: 'Female',
          title: 'Operator'
        },
        {
          id: 4,
          name: 'Thatcher Stave',
          email: 'tstave4@reference.com',
          gender: 'Male',
          title: 'Software Test Engineer III'
        },
        {
          id: 5,
          name: 'Clarinda Marieton',
          email: 'cmarietonh@theatlantic.com',
          gender: 'Female',
          title: 'Paralegal'
        },
        {
          id: 6,
          name: 'Clarinda Marieton',
          email: 'cmarietonh@theatlantic.com',
          gender: 'Female',
          title: 'Paralegal'
        },
        {
          id: 7,
          name: 'Clarinda Marieton',
          email: 'cmarietonh@theatlantic.com',
          gender: 'Female',
          title: 'Paralegal'
        }
      ]
    }),
    computed: {
      ...mapGetters([
        'getMasterDataByGroup',
        'getMasterDataName',
        'getUserProfile',
      ]),

      canSave() {
        return !!_(this.getEditingItems)
          .find(it => !!this.hasBeenChanged(it));
      },
      
    },



    validations: {
      dataForm: {

      },
    },

    methods: {



      onSelect (item) {
        this.selected = item;
      },



      async openDialog(existingUser) {
        console.log(existingUser);
        this.$v.dataForm.$reset();
        this.item = existingUser

        this.showDialog = true;

        if (this.mode ==='Booking')
        {
        console.log("get mode booking");
        console.log('fake');
       //await api.post("/api/w/DOs/getdoheader", 
       await newAPIPost("/api/w/DOs/getdoheader", 
        {
            salesOffice: existingUser.salesOffice,
            deliveryType: 'YY',
        }).then((res) => {
          console.log('finish');
          this.items = res;
          this.$store.commit('clearApiError');
          });


          
        }

        

        if (this.mode == 'Instruction')
        {
          this.instruction = existingUser.dispatcherInstruction
        }
         
        
      },

      getValidationClass(fieldName) {
        const field = _(this.$v)
          .lookup(fieldName);
        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty,
          };
        }
        return {};
      },


    //   handleStatusChanged(id, name) {
    //     console.log(`handleStatusChanged`, id, name);
    //     this.dataForm.loadStatus = id;
    //     //this.dataForm.loadStatus = name;
    //   },

     cancalAction(){
        this.showDialog = false;

        if (this.mode == 'Instruction')
        {
            this.item.dispatcherInstruction = this.instruction;
        }


         this.$store.commit('clearApiError');
     },

      async doSaveUser() {
        //this.$v.dataForm.$touch();
        console.log("ddd");

         if (this.mode ==='Booking'){

          console.log(this.selected);

        //await api.post("/api/w/DOs/WebAssignDoHeaderWithStage", 
        await newAPIPost("/api/w/DOs/WebAssignDoHeaderWithStage", 
        {
            doItem: this.selected,
            user: 'GST_SYSTEM',
            seqNo: this.item.seqNo,
        }).then((res) => {
          console.log('finish');
          this.$store.commit('clearApiError');
          });

           this.showDialog = false;
           $('.btn-search-export-form-container')
              .click();
         }

        if (this.mode == 'Instruction')
        {
            this.showDialog = false;
        }
          
      },
    },
  };
</script>
